import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Flex,
  Form,
  FormContext,
  GoogleAutocomplete,
  googlePlaceToAddress,
  Spinner,
  useGoogleApiLoader,
} from "dash-ui";

import { FormFields } from "containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants";
import { useGetUsStatesQuery } from "gql/generated.graphql";

const PlaceSelect = ({ defaultPlaceId }: { defaultPlaceId?: string }) => {
  const { t } = useTranslation(["forms", "common", "pages"]);
  const isGoogleApiReady = useGoogleApiLoader();
  // FIXME: re-check
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;
  const { data: statesData } = useGetUsStatesQuery();
  const { formErrors, stateHandlers } = useContext(FormContext);
  const [defaultViewValue, setDefaultViewValue] = useState("");
  const onPlaceSelected = (place: google.maps.places.PlaceResult) => {
    const address = googlePlaceToAddress(place);
    const states = statesData?.getUSStates || [];
    const addressState = {
      isoCode: states.find(({ name }) => name === address.state)?.code,
      name: address.state,
    };

    stateHandlers[FormFields.Place](place);
    stateHandlers[FormFields.Street](address.street);
    stateHandlers[FormFields.City](address.city);
    stateHandlers[FormFields.ZipCode](address.zipCode);
    stateHandlers[FormFields.State](addressState.name);
    stateHandlers[FormFields.County](address.county);
  };

  useEffect(() => {
    if (defaultPlaceId && geocoder) {
      geocoder.geocode({ placeId: defaultPlaceId }, (result) => {
        if (result?.length) {
          setDefaultViewValue(result[0].formatted_address);
        }
      });
    }
  }, [defaultPlaceId, geocoder]);

  return (
    <Form.Group w="100%" mb={3}>
      <Flex>
        <Form.Label required>{t("forms:labels.map")}</Form.Label>
      </Flex>

      {isGoogleApiReady ? (
        <GoogleAutocomplete
          defaultValue={defaultViewValue}
          onPlaceSelected={onPlaceSelected}
          placeholder={t("forms:placeholders:map") || ""}
          $errorType={formErrors[FormFields.Place]?.type}
        />
      ) : (
        <Spinner />
      )}
      <Form.Feedback $errorType={formErrors[FormFields.Place]?.type}>
        {formErrors[FormFields.Place]?.message}
      </Form.Feedback>
    </Form.Group>
  );
};

export default PlaceSelect;
